<template>
  <icon
    class="cursor-pointer"
    :icon="['fas', 'sun']"
    data-cy="dark-mode-switch-sun-icon"
    @click="toggleDarkMode(false)"
  />
  <InputSwitch
    :model-value="isDarkMode"
    class="mx-2"
    data-cy="dark-mode-switch-toggle"
    @update:model-value="toggleDarkMode()"
  />
  <icon
    class="cursor-pointer"
    :icon="['far', 'moon']"
    data-cy="dark-mode-switch-moon-icon"
    @click="toggleDarkMode(true)"
  />
</template>

<script setup lang="ts">
import { useSettingsStore } from "@/store";
const { isDarkMode, toggleDarkMode } = useSettingsStore();
</script>
